<script setup lang="ts">
import TheLogo from '../TheLogo.vue';
const emit = defineEmits(['close', 'back']);
withDefaults(
    defineProps<{
        isBorder?: boolean;
        isStatic?: boolean;
        isBackButton?: boolean;
        isCloseButton?: boolean;
    }>(),
    {
        isBackButton: false,
        isCloseButton: true
    }
);
</script>
<template>
    <div class="modal-header" :class="{ 'is-border': isBorder, 'is-static': isStatic }">
        <div class="modal-header__button is-back" v-if="isBackButton"><Button @click="emit('back')" severity="contrast" icon="pi pi-arrow-left" /></div>
        <slot name="title">
            <TheLogo class="size-12 translate-y-1" />
        </slot>
        <div class="modal-header__button" v-if="isCloseButton"><Button @click="emit('close')" severity="contrast" icon="pi pi-times" /></div>
    </div>
</template>

<style scoped lang="scss">
.modal-header {
    align-items: center;
    background: var(--primary);
    color: var(--white);
    display: flex;
    font-size: 16px;
    font-weight: 600;
    height: 100%;
    height: 50px;
    justify-content: center;
    left: 0;
    position: absolute;
    text-transform: uppercase;
    top: 0;
    z-index: 1;
    width: 100%;
    padding: 4px 0;
    h3 {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        margin: 0;
        max-width: calc(100% - 120px);
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        text-transform: uppercase;
        white-space: nowrap;
    }
    &__button {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        &.is-back {
            left: 15px;
            right: auto;
        }
    }
    &.is-border {
        border-radius: 10px 10px 0 0;
    }
    &.is-static {
        position: relative;
    }
    .is-mobile & {
        border-radius: 0;
    }
}
</style>
